export default __webpack_public_path__ + "static/media/enquieries-en.3504e9dc.png";